export const sessionStyles = theme => ({
    button: {
      margin: theme.spacing(),
    }
  })